import React from 'react';

const ranks = [
  { id: 'rank-1', name: 'Rookie Observer', xp: '0–500', icon: '👁️', active: false },
  { id: 'rank-2', name: 'Junior Psychic Consultant', xp: '501–1,500', icon: '🔮', active: false },
  { id: 'rank-3', name: 'Pineapple Tracker', xp: '1,501–3,500', icon: '🍍', active: true },
  { id: 'rank-4', name: 'Case File Specialist', xp: '3,501–7,000', icon: '🗂️', active: false },
  { id: 'rank-5', name: 'Santa Barbara Superfan', xp: '7,001–15,000', icon: '🌴', active: false },
  { id: 'rank-6', name: 'Head Psychic Investigator', xp: '15,001+', icon: '⭐', active: false },
];

const gameCategories = [
  { id: 'gc-1', name: 'Case File Trivia', count: '284 questions', icon: '🗂️' },
  { id: 'gc-2', name: 'Quote or Not', count: '156 quotes', icon: '💬' },
  { id: 'gc-3', name: 'Psychic Observation', count: '92 scenes', icon: '🔮' },
  { id: 'gc-4', name: 'Pineapple Hunt', count: '118 images', icon: '🍍' },
  { id: 'gc-5', name: 'Blueberry Challenge', count: '67 rounds', icon: '🚙' },
  { id: 'gc-6', name: 'Pop Culture Recall', count: '130 questions', icon: '📺' },
  { id: 'gc-7', name: 'Crime Scene Memory', count: '78 scenes', icon: '🔍' },
];

export default function PsychWorldSection() {
  return (
    <section id="psych-world" className="py-24 bg-muted/20 border-y border-border">
      <div className="px-6 max-w-screen-xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-secondary/10 border border-secondary/30 rounded-full px-4 py-1.5 mb-4">
            <span>🌴</span>
            <span className="text-xs font-semibold text-secondary uppercase tracking-wide">First Fan World Available Now</span>
          </div>
          <h2 className="text-hero-md font-extrabold text-foreground mb-4">
            Psych<br />
            <span className="gradient-text-blue">Case Files</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            The first FanFinite universe is inspired by the beloved detective comedy series.
            Fans compete as &quot;Psychos&quot; — climbing through 6 detective ranks using psychic instincts and obsessive show knowledge.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Rank ladder */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-5 flex items-center gap-2">
              <span>🏆</span> Fan Rank Ladder
            </h3>
            <div className="space-y-2">
              {ranks?.map((rank) => (
                <div
                  key={rank?.id}
                  className={`flex items-center gap-4 p-4 rounded-xl border transition-all duration-150 ${
                    rank?.active
                      ? 'bg-primary/10 border-primary/40 card-glow-yellow' :'bg-card border-border hover:border-border/80'
                  }`}
                >
                  <span className="text-2xl w-8 text-center">{rank?.icon}</span>
                  <div className="flex-1">
                    <p className={`text-sm font-bold ${rank?.active ? 'text-primary' : 'text-foreground'}`}>{rank?.name}</p>
                    <p className="text-xs text-muted-foreground font-mono-data">{rank?.xp} XP</p>
                  </div>
                  {rank?.active && (
                    <span className="text-[10px] font-bold bg-primary text-primary-foreground px-2 py-0.5 rounded-full">EXAMPLE</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Game categories */}
          <div>
            <h3 className="text-lg font-bold text-foreground mb-5 flex items-center gap-2">
              <span>🎮</span> Game Categories
            </h3>
            <div className="grid grid-cols-1 gap-2">
              {gameCategories?.map((cat) => (
                <div
                  key={cat?.id}
                  className="flex items-center gap-4 p-3.5 bg-card border border-border rounded-xl hover:border-secondary/40 hover:bg-secondary/5 transition-all duration-150 group cursor-default"
                >
                  <span className="text-xl w-8 text-center">{cat?.icon}</span>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-foreground">{cat?.name}</p>
                  </div>
                  <span className="text-xs text-muted-foreground font-mono-data">{cat?.count}</span>
                  <span className="w-2 h-2 rounded-full bg-positive opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}